import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { removeGiftTable, resetGiftTable } from 'store/actions/giftTable';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { useStorage64, useGiftTableInfo } from 'hooks';
import { AGENT_STAFF, CURRENT_GIFT_TABLE, SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { encodeStorage, removeStorage } from 'functions/storageBase64';
import { useDispatch } from 'store';
import { setLoginRedirect } from 'util/navigation';
import { PROJECT_BASENAME } from 'constants/env';
import GiftsHeader from '../../components/gifts-table/GiftsHeader';
// eslint-disable-next-line no-unused-vars
import HeroNewTable from './HeroNewTable';
import HeroSection from './HeroSection';
// eslint-disable-next-line no-unused-vars
import HomeFAQ from './HomeFAQ';
import HomeGifts from './HomeGifts';
import HomeReviews from './HomeReviews';
import HomeSteps from './HomeSteps';
import styles from './styles.module.scss';
import HomeBenefits from './HomeBenefits';
import PlanEvent from './PlanEvent';
import HomeConfianza from './HomeConfianza';
import { QuestionHome } from './HomeFAQ/QuestionHome/questionhome';
import Planes from './Planes';

const Home = () => {
  // TO-DO: perhaps this logout logic should be on GiftsHeader???
  const [isLogged] = useStorage64('session_token', '');
  const dispatch = useDispatch();
  const { hasGiftTableAndIsLogged } = useGiftTableInfo();

  const isLoggedIn = !!(isLogged && isLogged.length);
  localStorage.removeItem('giftTablesTotalbypass');

  useEffect(() => {
    if (!isLogged) {
      removeStorage(CURRENT_GIFT_TABLE);
      removeStorage(AGENT_STAFF);
      removeStorage(SEARS_PRODUCT);
      removeStorage(TOTAL_GIFT_TABLES);
      dispatch(removeGiftTable());
      dispatch(resetGiftTable());
    }
    // To Add Product From Sears
    const url = new URL(window.location);
    if(url.search.includes(SEARS_PRODUCT)) {
      //  console.log('A qui se agrega un regalo que viene desde el portal de Sears');
      const productUrl = url.search.replace(`?${SEARS_PRODUCT}=`, '');
      //  console.log('productUrl',productUrl);
      encodeStorage(SEARS_PRODUCT, productUrl);
      setTimeout(() => {
        window.location.href = `${PROJECT_BASENAME}my-table-bypass`;
      }, 3000);
    }
  }, [isLogged]);

  if (hasGiftTableAndIsLogged) {
    return <Redirect to="/my-table" />;
  }

  return (
    <>
      <Header type="complete" />
      <main className="gifts-root">
        <GiftsHeader />
        <HeroSection isLoggedIn={isLoggedIn} setLoginRedirect={setLoginRedirect} />
        <hr className={styles.hr}/>
        <HomeGifts isLoggedIn={isLoggedIn}  setLoginRedirect={setLoginRedirect} />
        <div className={styles['hr-red-container']}>
          <hr className={styles['hr-red']}/>
        </div>
        <HomeSteps isLoggedIn={isLoggedIn}  setLoginRedirect={setLoginRedirect} />
        {/* <HomeBenefits isLoggedIn={isLoggedIn}  setLoginRedirect={setLoginRedirect} /> */}
        <HomeBenefits isLoggedIn={isLoggedIn}  setLoginRedirect={setLoginRedirect} />
        <Planes />
        <PlanEvent/> 
        {/* <HeroNewTable isLoggedIn={isLoggedIn}  setLoginRedirect={setLoginRedirect} /> */}
        <HomeConfianza />
        <HomeReviews />
        <QuestionHome  />
      </main>
      <Footer type="complete" />
    </>
  );
};

export default Home;